import { render, staticRenderFns } from "./viewShortlist.vue?vue&type=template&id=b9f9ba08&"
import script from "./viewShortlist.vue?vue&type=script&lang=js&"
export * from "./viewShortlist.vue?vue&type=script&lang=js&"
import style0 from "./viewShortlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports